const TYPE_PIECE = {
  DEPENSE: {
    ORDINAIRE: '01',
    CORRECTIF: '02',
    ORDRE_BUDGET: '03',
    ORDRE_MIXTE: '04',
    EMIS_APRES_PAIE: '05',
    GLOBAL: '06',
    ADMISSION_NON_VALEURS: '07',
    COLLECTIF: '08',
    MARCHE: '09',
    RATTACHEMENT: '10',
    ORDRE_PAIEMENT: '11',
    CHARGES_CONSTAT_AVANCE: '13',
  },
  DEPENSE_LIST: [
    {
      key: '01',
      text: '01 - Mandat ordinaire',
      value: '01',
    },
    {
      key: '02',
      text: '02 - Mandat correctif',
      value: '02',
    },
    {
      key: '03',
      text: "03 - Mandat d'ordre budgétaire",
      value: '03',
    },
    {
      key: '04',
      text: "04 - Mandat d'ordre mixte",
      value: '04',
    },
    {
      key: '05',
      text: '05 - Mandat émis après paiement',
      value: '05',
    },
    {
      key: '06',
      text: '06 - Mandat global',
      value: '06',
    },
    {
      key: '07',
      text: "07 - Mandat d'admission en non valeurs",
      value: '07',
    },
    {
      key: '08',
      text: '08 - Mandat collectif',
      value: '08',
    },
    {
      key: '09',
      text: '09 - Mandat sur marché',
      value: '09',
    },
    {
      key: '10',
      text: '10 - Mandat de rattachement',
      value: '10',
    },
    {
      key: '11',
      text: '11 - Ordre de paiement',
      value: '11',
    },
    {
      key: '13',
      text: "13 - Charges constatées d'avance",
      value: '13',
    },
  ],
  RECETTE: {
    ORDINAIRE: '01',
    CORRECTIF: '02',
    ORDRE_BUDGET: '03',
    ORDRE_MIXTE: '04',
    EMIS_APRES_PAIE: '05',
    RECAP_AVEC_ROLE: '06',
    RECAP_SANS_ROLE: '07',
    MAJORATION: '09',
    PLUSIEURS_ANNEES: '10',
    RATTACHEMENT: '11',
    ORDRE_RECETTE_ORDO: '12',
    PROD_CONSTATES_AVANCE: '14',
    ORMC: '15',
  },
  RECETTE_LIST: [
    {
      key: '01',
      text: '01 - Titre ordinaire',
      value: '01',
    },
    {
      key: '02',
      text: '02 - Titre correctif',
      value: '02',
    },
    {
      key: '03',
      text: "03 - Titre d'ordre budgétaire",
      value: '03',
    },
    {
      key: '04',
      text: "04 - Titre d'ordre mixte",
      value: '04',
    },
    {
      key: '05',
      text: '05 - Titre émis après paiement',
      value: '05',
    },
    {
      key: '06',
      text: '06 - Titre récapitulatif avec rôle',
      value: '06',
    },
    {
      key: '07',
      text: '07 - Titre récapitulatif sans rôle',
      value: '07',
    },
    {
      key: '09',
      text: '09 - Titre de majoration',
      value: '09',
    },
    {
      key: '10',
      text: '10 - Titre en plusieurs années',
      value: '10',
    },
    {
      key: '11',
      text: '11 - Titre de rattachement',
      value: '11',
    },
    {
      key: '12',
      text: '12 - Ordre de recette ordonnateur',
      value: '12',
    },
    {
      key: '14',
      text: "14 - Produits constatés d'avance",
      value: '14',
    },
    {
      key: '15',
      text: '15 - Titre ORMC',
      value: '15',
    },
  ],
} as const;

export default TYPE_PIECE;
